<template>
  <div class="card my-2" v-if="(series && series.length) || loading">
    <div class="card-header">
      <div class="row align-items-center">
        <div class="col-lg-6">
          <div class="cui__utils__heading mb-0">
            <strong
              >Daily Consumption Distribution of
              {{
                common.handlePaymentModelName(accountData.payment_model)
              }}</strong
            >
          </div>
        </div>
      </div>
    </div>
    <div class="card-body" style="text-align: center">
       <v-progress-circular
          v-if="loading"
          indeterminate
          color="primary"/>
      <apex-chart
        v-if="series && series.length && !loading"
        :options="options"
        :series="series"
        :height="400"
      />
    </div>
  </div>
</template>

<script>
import insights from '@/utils/analytics/insights'
import apexChart from 'vue-apexcharts'
import common from '@/utils/analytics/common'
export default {
  name: 'DailyConsumption',
  components: {
    apexChart
  },
  props: {
    from: {
      type: String,
      default: null
    },
    to: {
      type: String,
      default: null
    },
    accountData: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },
  data() {
    return {
      common,
      consumptionData: [],
      loading: false,
      series: [],
      options: {
        colors: [],
        chart: {
          type: 'bar',
          height: 350,
          stacked: true
        },
        plotOptions: {
          bar: {
            horizontal: false
          }
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        dataLabels: {
          enabled: true,
          formatter: function (value) {
            return common.numberWithCommas(value)
          }
        },
        xaxis: {
          categories: [],
          title: {
            text: ''
          },
          type: 'datetime'
        },
        yaxis: {
          title: {
            text: undefined
          },
          labels: {
            formatter(value) {
              return common.numberWithCommas(value)
            }
          }
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        },
        fill: {
          opacity: 1
        },
        legend: {
          position: 'bottom',
          offsetX: 40
        }
      }
    }
  },
  watch: {
    from() {
      this.getConsumptionData()
    },
    to() {
      this.getConsumptionData()
    }
  },
  mounted() {
    this.getConsumptionData()
  },
  methods: {
    getConsumptionData() {
      this.loading = true
      let data = insights.channelsConsumptionPerDay({
        params: {
          from: this.from,
          to: this.to
        }
      })
      data
        .then((data) => {
          this.consumptionData = data
          this.drawConsumptionGraph()
        })
        .catch(() => {
          this.loading = false
        })
    },
    drawConsumptionGraph() {
      // console.log('drawing')
      if (
        !this.consumptionData.channels ||
        !this.consumptionData.channels.length
      ) {
        this.loading = false
        return
      }
      this.options.xaxis.categories = []
      this.series = []
      setTimeout(() => {
        this.options.colors = this.consumptionData.channels.map(
          (c) =>
            common.getSocialIcon(c.slug.toLowerCase()).colorHexa || '#ff1744'
        )
        this.options.xaxis.categories = this.consumptionData.dates
        this.series = this.consumptionData.channels.map((c) => ({
          name: common.handleChannelName(c.name),
          data: c.data.map((d) => parseFloat(d, 10))
        }))
        this.loading = false
      }, 1200)
    }
  }
}
</script>

<style src="@/assets/css/bs-helpers.css" lang="css" scoped/>
